import React, { PureComponent } from 'react'

import InlineSVG from 'svg-inline-react'

export default class ArtistIcon extends PureComponent
{
	render ()
	{
		const component = this, props = this.props, state = this.state;

		const svg_source =
		(
			`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 48 48">

				<g>
					<path fill="currentColor" d="M22.223 20.99l2.739-2.739 1.096 1.096-2.739 2.739-1.096-1.096z" />
					<path fill="currentColor" d="M41.404 2.902c-3.77-3.77-10.28-3.968-14.248 0-3.024 3.024-2.948 6.916-2.948 6.916l0.255 0.255-20.815 25.218 2.173 2.173c-0.992 1.313-1.219 3.005-0.576 4.564 0.737 1.767 2.381 2.872 4.299 2.872h5.367c1.71 0 3.099 1.389 3.099 3.099h1.55c0-2.561-2.088-4.649-4.649-4.649h-5.367c-1.531 0-2.485-0.992-2.863-1.918-0.321-0.784-0.387-1.89 0.255-2.863l2.098 2.098 25.199-20.825 0.255 0.255c0 0 4.072-0.104 6.916-2.948 3.931-3.931 3.931-10.318 0-14.248zM9.128 38.58l-3.392-3.392 3.401-4.12 4.101 4.101-4.11 3.411zM14.448 34.177l-4.309-4.309 15.439-18.689 7.559 7.568-18.689 15.429zM35.093 18.511l-9.288-9.288c0.113-1.181 0.472-2.315 1.039-3.345l11.593 11.593c-1.020 0.567-2.154 0.926-3.345 1.039zM40.308 16.055c-0.18 0.18-0.378 0.359-0.576 0.52l-12-12c0.161-0.198 0.34-0.387 0.52-0.576 3.335-3.335 8.872-3.184 12.056 0 3.326 3.326 3.326 8.73 0 12.056z" />
				</g>

			</svg>`
		);

		let output =
		(
			<InlineSVG src={ svg_source } className={ props.className }
				raw={ true }
			/>
		);

		return output;
	}
}
